import { Serializable } from "../../../tendercuts/models/base";

export class ValidateCouponCode implements Serializable<ValidateCouponCode> {
  public status: boolean;
  private discount_amount: number = 0;
  private rewards_earned: number;
  private coupon_code: string;
  // cart product id's with discount amount
  public items: { [productId: number]: number } = {};

  get discountAmount() {
    return this.discount_amount;
  }

  get couponCode() {
    return this.coupon_code;
  }

  get rewardsEarned(): number {
    return this.rewards_earned;
  }

  deserialize(input) {
    this.status = input.status;
    this.discount_amount = input.discount_amount;
    this.coupon_code = input.coupon_code;
    this.items = input.items;
    this.rewards_earned = input.rewards_earned;

    return this;
  }
}
